import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import isNull from "../../../../../mixin/isNull";
import {useParams} from "react-router";
import QualityInspection from "../../../../../entity/emergency/QualityInspection";
import useStepAppointmentDemo from "./useStepAppointmentDemo";
import useStepTravelDemo from "./useStepTravelDemo";
import useStepPictureBeforeDemo from "./useStepPictureBeforeDemo";
import useStepQuotationDemo from "./useStepQuotationDemo";
import useStepQuotationValidationDemo from "./useStepQuotationValidationDemo";
import useStepQuotationValidatedDemo from "./useStepQuotationValidatedDemo";
import useStepWorkDemo from "./useStepWorkDemo";
import useStepPictureAfterDemo from "./useStepPictureAfterDemo";
import useStepDeliveryDemo from "./useStepDeliveryDemo";
import useStepTerminateDemo from "./useStepTerminateDemo";

export default function () {
    const {token} = useParams();
    const stepAppointmentDemo = useStepAppointmentDemo();
    const stepTravelDemo = useStepTravelDemo();
    const stepPictureBeforeDemo = useStepPictureBeforeDemo();
    const stepQuotationDemo = useStepQuotationDemo();
    const stepQuotationValidationDemo = useStepQuotationValidationDemo();
    const stepQuotationValidatedDemo = useStepQuotationValidatedDemo();
    const stepWorkDemo = useStepWorkDemo();
    const stepPictureAfterDemo = useStepPictureAfterDemo();
    const stepDeliveryDemo = useStepDeliveryDemo();
    const stepTerminateDemo = useStepTerminateDemo();
    const intervention = useSelector(state => state.api?.emergency?.interventions?.find(i => i?.getToken() === token));
    /** @type QualityInspection */
    const qualityInspection = useSelector(state => state.api?.emergency?.quality_inspections?.[intervention?.getQualityInspectionId()]);
    const [start, setStart] = useState(false);

    useEffect(() => {
        return () => {
            if (!isNull(window.sound)) {
                window.sound.pause();
                window.sound.currentTime = 0;
            }
        }
    }, []);

    useEffect(() => {
        if (isNull(qualityInspection) || !start) return;

        play();
    }, [qualityInspection?.getCurrentStep(), qualityInspection?.getCurrentSubStep(), start]);

    const play = () => {
        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_INITIALIZED) {
            stepAppointmentDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_APPOINTMENT) {
            stepTravelDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_TRAVEL) {
            stepPictureBeforeDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_PICTURE_BEFORE) {
            stepQuotationDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_QUOTATION
            && qualityInspection.getCurrentSubStep() === QualityInspection.SUB_STEP_ALL_TO_VALIDATE) {
            stepQuotationValidationDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_QUOTATION
            && qualityInspection.getCurrentSubStep() === QualityInspection.SUB_STEP_ALL_VALIDATED) {
            stepQuotationValidatedDemo.launch(true, token === "demo");
            return;
        }


        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_CLIENT_SIGNATURE) {
            stepWorkDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_WORK) {
            stepPictureAfterDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_PICTURE_AFTER) {
            stepDeliveryDemo.launch(true, token === "demo");
            return;
        }

        if (qualityInspection.getCurrentStep() === QualityInspection.STEP_DELIVERY) {
            stepTerminateDemo.launch(true, token === "demo");
            return;
        }
    }

    return {start: () => setStart(true)};
}